var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-height":"500px"}},[_c('TreeTable',{ref:"treeTable",attrs:{"data":_vm.departmentsList,"columns":_vm.columns,"loading":_vm.loadingStaus,"highlight-current-row":"","height":"500"},on:{"handleSelectionChange":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"55"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }